export interface PPMCountDetails {
  identifier?: string;
  objectId?: number;
  floorId?: number;
  floorName?: string;
  blockId?: number;
  blockName?: string;
  urn?: string;
  tpId?: number;
  department?: string;
  criticality?: string;
}
